import $ from 'jquery';

const selectors = {
  slider: '[data-slider-selector]',
}

const slickSlider = {
  onLoad() {
    let $container = $(this.container),
        $slider = $container.find(selectors.slider);
    initSlider($slider);
  },
};

function initSlider($slider) {
  $slider.slick();
}

export default slickSlider;
